import { styled } from '@compiled/react';
import { withAnalyticsContext, withAnalyticsEvents, createAndFireEvent } from '@atlaskit/analytics-next';
import { DropdownItem } from '@atlaskit/dropdown-menu';

const NoUnderlineDropdownItem = styled(DropdownItem)({
    textDecoration: 'none',
    '&:focus, &:hover, &:visited, &:link, &:active': {
        textDecoration: 'none',
    },
});
export const NoUnderlineDropdownItemWithAnalytics = withAnalyticsContext({
    componentName: 'dropdownItem',
})(
    withAnalyticsEvents({
        onClick: createAndFireEvent('atlaskit')({
            action: 'clicked',
            actionSubject: 'dropdownItem',
        }),
    })(NoUnderlineDropdownItem)
);
